import { UserManagerSettings } from 'oidc-client-ts';

// AWS Cognito OIDC Configuration
const cognitoUserPoolId = process.env.REACT_APP_USER_POOL_ID || 'your-user-pool-id';
const cognitoClientId = process.env.REACT_APP_USER_POOL_CLIENT_ID || 'your-client-id';
const cognitoRegion = process.env.REACT_APP_COGNITO_REGION || 'us-east-1';
const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN || 'your-cognito-domain.auth.us-east-1.amazoncognito.com';

export const oidcConfig: UserManagerSettings = {
  authority: `https://${cognitoDomain}`,
  client_id: cognitoClientId,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/silent-callback`,
  loadUserInfo: false, // Cognito doesn't support userinfo endpoint by default
  metadata: {
    issuer: `https://cognito-idp.${cognitoRegion}.amazonaws.com/${cognitoUserPoolId}`,
    authorization_endpoint: `https://${cognitoDomain}/oauth2/authorize`,
    token_endpoint: `https://${cognitoDomain}/oauth2/token`,
    jwks_uri: `https://cognito-idp.${cognitoRegion}.amazonaws.com/${cognitoUserPoolId}/.well-known/jwks.json`,
    end_session_endpoint: `https://${cognitoDomain}/logout`
  }
};

// Custom Cognito logout URL builder
export const buildCognitoLogoutUrl = () => {
  const logoutUri = encodeURIComponent(window.location.origin);
  return `https://${cognitoDomain}/logout?client_id=${cognitoClientId}&logout_uri=${logoutUri}`;
};

export default oidcConfig;